
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(12(17|84)|75(70|98)|2339|324|3887|6083|6904|8250|8899|9562|9740)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
